// General is the default layout, designed to present standard, textual pages that don't require any additional styling.
import Menu from '@/components/menu/component'
import Notice from '@/components/notice/component'
import Foot from '@/components/foot/component'

export default {
  name: 'general-layout',
  components: { Menu, Notice, Foot }
}



// WEBPACK FOOTER //
// ./src/layouts/general/script.js